import {
  CsvFieldByHeader,
  downloadCsv,
  recordsFromCsv,
} from "../../components/massFlow/csv";
import { emptyPort, PortPayload } from "../types";

export const CSV_HEADERS = ["Operador", "Porta"];

const CSV_EXAMPLES = [
  [">", "1024"],
  ["=", "443"],
];

const FIELD_BY_HEADER: CsvFieldByHeader = {
  operador: "operator",
  operator: "operator",
  operacao: "operator",
  comparador: "operator",
  porta: "port",
  port: "port",
  portas: "port",
  numeroporta: "port",
  numerodaporta: "port",
};

export function portsFromCsv(text: string): PortPayload[] {
  return recordsFromCsv(text, {
    fieldByHeader: FIELD_BY_HEADER,
    emptyValues: emptyPort,
    expectedHeaders: CSV_HEADERS,
  });
}

export function downloadCsvTemplate() {
  downloadCsv("MW Soluções - Template Portas.csv", [
    CSV_HEADERS,
    ...CSV_EXAMPLES,
  ]);
}
